/*eslint-disable */
/**
 * Utilizes the @getgo auth client library to handle auth tokens.
 * For more details: https://bitbucket.ops.expertcity.com/projects/WC/repos/getgo-auth-client/browse
 */
define('lib/auth/auth',['require','exports','module','web-urls','js-cookie','@getgo/auth-client'],function (require, exports, module) {
    var webUrls = require('web-urls');
    var Cookies = require('js-cookie');
    var cookies = Cookies.withConverter({
        read: function (encodedValue, name) {
            return atob(encodedValue);
        },
        write: function (value, name) {
            return btoa(value);
        }
    });

    var ACCESS_TOKEN_COOKIE_KEY = '__Host-webAppAccessToken';
    var accessTokenCookieOptions = { expires: 30, secure: true };

    var Auth = require('@getgo/auth-client').default;

    var options = {
        client_id: webUrls.get('oauthClientId'),
        url: webUrls.get('oauthSvcUrl'),
        redirect_url: webUrls.get('baseUrl'),
        state: {}
    };

    var auth = new Auth(options);

    module.exports = {

        updateState: function (updatedState) {
            Object.assign(options.state, updatedState);
            auth = new Auth(options);
        },

        getToken: function () {
            var cookie = cookies.get(ACCESS_TOKEN_COOKIE_KEY);
            return auth.init(cookie ? JSON.parse(cookie) : undefined);
        },

        retrieveFreshToken: function (settings) {
            var localSettings = settings || window.location;
            this.getToken();
            this.updateState({hash: localSettings.hash});
            this.clearToken();
            auth.login();
        },

        ensureTokenSet: function (settings) {
            if (!this.getToken()) {
                this.retrieveFreshToken(settings);
            }
        },

        setUpToken: function () {
            var token = this.getToken();

            if (token) {
                // Redirection from CAS strips any hash information, including the intended route.
                // If a hash fragment was provided previously, it will be saved as part of the token state.
                // Take the hash and add it to the URL so the Durandal Router will navigate to the correct page.
                if (token.state && token.state.hash) {
                    window.location.hash = token.state.hash;
                    token.state.hash = null;
                }
                cookies.set(ACCESS_TOKEN_COOKIE_KEY, token, accessTokenCookieOptions);
                return token.access_token;
            }
            return undefined;
        },

        clearToken: function () {
            cookies.remove(ACCESS_TOKEN_COOKIE_KEY, accessTokenCookieOptions);
        },

        logout: function () {
            this.clearToken();
            auth.logout(options);
        }
    };
});

